import { useMemo, useState, useEffect } from 'react';
import Card from '../../../../componentes/contenedores/Card';
import Page from '../../../../componentes/plantilla/Page';
import { useContextEmpleado } from '../../../../contexto/empleado/EmpleadoContext';
import {useContextUsuario} from '../../../../contexto/usuario/UsuarioContext';
import {AxiosPublico} from '../../../../componentes/axios/Axios';
import TablaPedidos from './TablaBuscarPedidos';
import { formatoFecha } from '../../../../configuracion/validaciones';
import moment from 'moment';
import { PedidosFiltro } from '../../../../configuracion/apiUrls';
import { mostraAlertaError } from '../../../../componentes/alerts/sweetAlert';
import ModalBootstrap from '../../../../componentes/modal/ModalBootstrap';


const HomeBuscarPedidos = () => {
    const { usuario, estacion } = useContextUsuario();
      
    const { listaPedidos, listaClientes, ActualizarLista } = useContextEmpleado();
    //const [panelAbierto, setPanelAbierto] = useState(false);
    const [fechaFiltro, setFechaFiltro] = useState(formatoFecha(new Date()));
    const [fechaFiltroTemp, setFechaFiltroTemp] = useState(formatoFecha(new Date()));
    
    const clientes = listaClientes || [];
    const [clienteId, setClienteId] = useState("");
    const [modalClienteOpen, setModalClienteOpen] = useState(false);
  const [clienteSearchTerm, setClienteSearchTerm] = useState("");
  
      const [empleadoId, setEmpleadoId] = useState("");
      const [panelAbierto, setPanelAbierto] = useState(false);
      const [fechaInicio, setFechaInicio] = useState(
        moment().subtract(1, "days").format("YYYY-MM-DD")
      );
      const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
      const [incluirEmpleado, setIncluirEmpleado] = useState(true);
      const [estadoFiltro, setEstadoFiltro] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState({});
    const filteredClientes = clientes.filter((cliente) => {
    const searchTerm = clienteSearchTerm.trim().toLowerCase();

    // 1. Búsqueda por Nombre Completo del Cliente
    const nombreClienteMatch = cliente.nombreCompleto
      .toLowerCase()
      .includes(searchTerm);

    // 2. Búsqueda por Nombre de la Empresa del Cliente
    const nombreEmpresaMatch =
      cliente.ClienteEmpresas &&
      cliente.ClienteEmpresas.some((empresa) =>
        empresa.nombre.toLowerCase().includes(searchTerm)
      );

    // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
    return nombreClienteMatch || nombreEmpresaMatch;
  });
  const [paginaCliente, setPaginaCliente] = useState(1);
  const clientesPorPagina = 5;
  const indexUltimoCliente = paginaCliente * clientesPorPagina;
  const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
  const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
  const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);


      

    useEffect(() => {
        fetchPedidosCliente();
    }, [empleadoId, fechaInicio, fechaFin, clienteId, incluirEmpleado]);


    const fetchPedidosCliente = async () => {
        try {
            const params = new URLSearchParams();
            if (selectedEvent.clienteId) params.append("clienteId", selectedEvent.clienteId);
            if (incluirEmpleado && usuario.datoPersonales.id) {
                params.append("empleadoId", usuario.datoPersonales.id);
            }
            if (fechaInicio) params.append("fechaInicio", moment(fechaInicio).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
            if (fechaFin) params.append("fechaFin", moment(fechaFin).endOf('day').format('YYYY-MM-DD HH:mm:ss'));

            const response = await AxiosPublico.get(`${PedidosFiltro}?${params.toString()}`);

            if (Array.isArray(response.data)) {
                let pedidosFiltrados = response.data;

                if (estadoFiltro) {
                    pedidosFiltrados = pedidosFiltrados.filter(pedido => pedido.estado === estadoFiltro);
                }

                const transformados = pedidosFiltrados.map((pedido) => ({
                    id: pedido.id,
                    fechaOriginal: pedido.fecha,
                    fecha: moment(pedido.fecha).format("YYYY-MM-DD HH:mm"),
                    estado: pedido.estado,
                    envio: pedido.envio,
                    notas: pedido.notas || "Sin nota",
                    total: pedido.pedidoDetalles
                        ?.reduce(
                            (sum, item) =>
                                sum + parseFloat(item.precio || 0) * (item.cantidad || 1),
                            0
                        )
                        .toFixed(2),
                    Cliente: pedido.Cliente,
                    Empleado: pedido.Empleado,
                    nombreEmpleado: pedido.Empleado?.nombreCorto || "Sin empleado",
                    nombreCliente: pedido.Cliente?.nombreCorto || "Sin nombre",
                    clienteRtn: pedido.rtn || "Sin rtn",
                    clienteId: pedido.clienteId || "Sin id de cliente",
                    detalles: pedido.pedidoDetalles?.map((detalle) => ({
                        id: detalle.id,
                        productoId: detalle.producto?.id || null,
                        nombre: detalle.producto?.nombre || "Producto no especificado",
                        codigo: detalle.producto?.codigo || "Sin código",
                        cantidad: detalle.cantidad || 1,
                        precio: parseFloat(detalle.precio || 0).toFixed(2),
                        subtotal: (detalle.cantidad * parseFloat(detalle.precio)).toFixed(2),
                        lote: detalle.lote,
                        loteinventario: detalle.loteinventario,
                        inventarioTipo: detalle.inventarioTipo
                    })),
                    direcciones: pedido.PedidoDireccions?.map((direccion) => ({
                        id: direccion.id,
                        direccion: direccion.direccion,
                        longitud: direccion.longitud || null,
                        latitud: direccion.latitud || null
                    })) || []
                }));
                transformados.sort((a, b) =>
                    moment(b.fechaOriginal).valueOf() - moment(a.fechaOriginal).valueOf()
                );
                setPedidos(transformados);
                //console.log(transformados);
            }
        } catch (error) {
            mostraAlertaError("Error al obtener los pedidos.", "Error");
        }
    };

    const handleClienteSeleccionado = (cliente) => {
    setSelectedEvent((prev) => ({
      ...prev,
      clienteId: cliente.id,
      clienteNombre: cliente.nombreCompleto,
    }));
    setModalClienteOpen(false);
  };

    const datos = {
        titulo: {
            titulo: "Busqueda de pedidos",
            url: "/app/admin/pedidos/buscar",
            tituloUrl: "pedidos",
            nombreUrl: "Buscar"
        }
    };

    const pedidosFiltrados = useMemo(() => {
        let pedidos = Array.isArray(listaPedidos) ? listaPedidos : [];

        if (fechaFiltro) {
            pedidos = pedidos.filter((p) => {
                if (!p?.fecha) return false;

                return formatoFecha(p.fecha) === fechaFiltro;
            });
        }

        return pedidos;
    }, [listaPedidos, fechaFiltro]);

    const handleFiltrar = () => {
        setFechaFiltro(fechaFiltroTemp);
        const fechaInicio = fechaFiltroTemp;
        if (fechaInicio) {
            const valorFecha = moment(fechaInicio).startOf('day').format('YYYY-MM-DD HH:mm:ss');
            //console.log("Parámetro 'fechaInicio' preparado para API:", valorFecha);
        }
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setFechaFiltro(moment().format("YYYY-MM-DD"));
        setFechaFiltroTemp(moment().format("YYYY-MM-DD"));
        setPanelAbierto(false);
    };

    const renderFilterPanel = () => (
        <div className="mb-4 d-flex justify-content-end">
            <div className="position-relative">
                <button
                    className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                    onClick={() => setPanelAbierto(!panelAbierto)}
                    style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "0.9rem",
                        minWidth: "140px",
                    }}
                >
                    <span className="d-flex align-items-center">
                        <i className="fas fa-filter mx-2"></i>
                        Filtros
                    </span>
                    <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                </button>

                {panelAbierto && (
                    <div
                        className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                        style={{
                            minWidth: "280px",
                            right: 0,
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                            zIndex: 1050,
                        }}
                    >
                        <div className="form-group mb-3">
                            <label htmlFor="fechaFiltro">Filtrar por fecha:</label>
                            <input
                                id="fechaFiltro"
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaFiltroTemp}
                                onChange={(e) => setFechaFiltroTemp(e.target.value)}
                            />
                        </div>

                        <div className="d-flex">
                            <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                <i className="fas fa-filter mx-1"></i> Filtrar
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                <i className="fas fa-sync-alt mx-1"></i> Reset
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <Page datos={datos}>
            <Card titulo="Lista de Pedidos">
                <div className="mb-4 d-flex justify-content-end">
          <div className="position-relative">
            <button
              className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
              onClick={() => setPanelAbierto(!panelAbierto)}
              style={{
                borderRadius: "6px",
                padding: "6px 12px",
                fontSize: "0.9rem",
                minWidth: "140px",
              }}
            >
              <span className="d-flex align-items-center">
                <i className="fas fa-filter mx-2"></i>
                Filtros
              </span>
              <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
            </button>

            {panelAbierto && (
              <div
                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                style={{
                  minWidth: "240px",
                  right: 0,
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  padding: "15px",
                  zIndex: 1050,
                  border: "1px solid red",
                }}
              >
                <div className="mb-3">
                  <label className="form-label">Fecha inicio</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Fecha fin</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Cliente</label>
                  <div className="d-flex align-items-center">
                    {selectedEvent.clienteNombre ? (
                      <span className="text-success fw-bold">{selectedEvent.clienteNombre}</span>
                    ) : (
                      <span className="text-muted">Ninguno seleccionado</span>
                    )}
                  </div>
                  <ModalBootstrap
                    titulo="Seleccionar cliente"
                    nombreBoton="Buscar"
                    estiloBoton="btn btn-sm btn-outline-primary mt-2"
                    iconBoton="fa-solid fa-magnifying-glass"
                    modalIsOpen={modalClienteOpen}
                    setModalIsOpen={setModalClienteOpen}
                  >
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar cliente..."
                        value={clienteSearchTerm}
                        onChange={(e) => setClienteSearchTerm(e.target.value)}
                      />
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped table-hover shadow-smr">
                        <thead className="bg-dark text-white">
                          <tr>
                            <th>ID</th>
                            <th>Empresas</th>
                            <th>Nombre completo</th>
                            <th>Agregar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {clientesPagina.length > 0 ? (
                            clientesPagina.map((cliente) => (
                              <tr key={cliente.id}>
                                <td>{cliente.id}</td>
                                <td className="align-middle">
                                  {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                    ? cliente.ClienteEmpresas.map((empresa, index) => (
                                      <div key={index} className="mb-1">
                                        {empresa.nombre}
                                      </div>
                                    ))
                                    : "N/A"}
                                </td>
                                <td>{cliente.nombreCompleto}</td>
                                <td className="text-center align-middle">
                                  <button
                                    className="btn btn-success btn-sm"
                                    onClick={() =>
                                      handleClienteSeleccionado(cliente)
                                    }
                                  >
                                    <i className="fa-regular fa-square-check" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center text-muted">
                                No se encontraron clientes.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-flex justify-content-center">
                        <nav className="mt-2">
                          <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                            {/* Botón "Anterior" */}
                            <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                              <button
                                className="page-link"
                                onClick={() => setPaginaCliente(paginaCliente - 1)}
                                aria-label="Anterior"
                              >
                                <i className="fas fa-chevron-left me-1"></i> Anterior
                              </button>
                            </li>

                            {
                              (() => {
                                const pagesToShow = 5;
                                const halfPages = Math.floor(pagesToShow / 2);
                                let startPage = Math.max(1, paginaCliente - halfPages);
                                let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                                if (paginaCliente <= halfPages) {
                                  endPage = Math.min(totalPaginasCliente, pagesToShow);
                                }
                                if (paginaCliente > totalPaginasCliente - halfPages) {
                                  startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                                }

                                const pageButtons = [];
                                for (let i = startPage; i <= endPage; i++) {
                                  pageButtons.push(
                                    <li
                                      key={i}
                                      className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                    >
                                      <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                        {i}
                                      </button>
                                    </li>
                                  );
                                }
                                return pageButtons;
                              })()
                            }

                            {/* Botón "Siguiente" */}
                            <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                              <button
                                className="page-link"
                                onClick={() => setPaginaCliente(paginaCliente + 1)}
                                aria-label="Siguiente"
                              >
                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </ModalBootstrap>
                </div>
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="incluirEmpleado"
                    checked={!incluirEmpleado}
                    onChange={() => setIncluirEmpleado(!incluirEmpleado)}
                  />
                  <label className="form-check-label ms-2" htmlFor="incluirEmpleado">
                    Solo mis pedidos
                  </label>
                </div>
                <div className="form-group me-2 mb-3">
                  <label htmlFor="estadoFiltro">Estado</label>
                  <select
                    id="estadoFiltro"
                    className="form-control form-control-sm"
                    value={estadoFiltro}
                    onChange={(e) => setEstadoFiltro(e.target.value)}
                  >
                    <option value="">Todos</option>
                    <option value="Pendiente">Pendiente</option>
                    <option value="Programada">Programada</option>
                    <option value="Completada">Completada</option>
                    <option value="Cancelada">Cancelada</option>
                  </select>
                </div>
                <div className="d-flex">
                  <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                    <i className="fas fa-filter mx-1"></i> Filtrar
                  </button>
                  <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                    <i className="fas fa-sync-alt mx-1"></i> Reset
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
                <TablaPedidos datos={pedidos}></TablaPedidos>
            </Card>
        </Page>
    );
}

export default HomeBuscarPedidos;